
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/corporate_product",
      function () {
        return require("private-next-pages/gifts/corporate_product.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/corporate_product"])
      });
    }
  